export var sprintTheme = {
    colors: {
        primary: "#FCCE0A",
        secondary: "#000",
        grayDarker: "#3F3F3F",
        grayDark: "#949599",
        gray: "#D5D6DA",
        grayLight: "#E6E6EB",
        grayLighter: "#F0F0F5",
        lightRed: "#FF4349",
        red: "#C70032",
        orange: "#FF8500",
        darkOrange: "#D36C00",
        green: "#3DA930",
        darkGreen: "#2D7E24",
    },
    typography: {
        bodyColor: "#000",
        fontFamily: "'Sprint Sans Regular', 'neue-haas-grotesk-display', sans-serif",
        fontSize: "100%",
        title: {
            fontSizeMobile: 48,
            fontSizeTablet: 75,
            fontSize: 75,
            lineHeight: "1.05",
            fontWeight: "bold",
        },
        heading2: {
            fontSizeMobile: 40,
            fontSizeTablet: 48,
            fontSize: 60,
            lineHeight: "1.05",
            fontWeight: "bold",
        },
        heading3: {
            fontSizeMobile: 24,
            fontSizeTablet: 24,
            fontSize: 40,
            lineHeight: "1.15",
            fontWeight: "bold",
        },
        heading4: {
            fontSizeMobile: 24,
            fontSizeTablet: 24,
            fontSize: 32,
            lineHeight: "1.2",
            fontWeight: "normal",
        },
        heading5: {
            fontSizeMobile: 48,
            fontSizeTablet: 32,
            fontSize: 32,
            lineHeight: "1.2",
            fontWeight: "normal",
        },
        heading6: {
            fontSizeMobile: 24,
            fontSizeTablet: 24,
            fontSize: 24,
            lineHeight: "1.35",
            fontWeight: "normal",
        },
        body: {
            fontSizeMobile: 16,
            fontSizeTablet: 16,
            fontSize: 16,
            lineHeight: "1.5",
            fontWeight: "normal",
        },
    },
};
